import React from 'react'
import PropTypes from 'prop-types'
import { InputSwitch } from 'primereact/inputswitch'
import { Col, Label, FormGroup } from 'reactstrap'
import './CustomPrime.css'

function CustomSwitchComponent({ checked, onChange, name, labelName, col, formClassName, paddingNone }) {
  return (
    <>
      <FormGroup className={formClassName}>
        {labelName ? <Label>{labelName}:</Label> : null}

        <Col md={col} className={paddingNone ? 'p-0' : ''}>
          <InputSwitch checked={checked} onChange={onChange} name={name} labelname={labelName} />
        </Col>
      </FormGroup>
    </>
  )
}

CustomSwitchComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  col: PropTypes.number,
  labelName: PropTypes.string,
}

export default CustomSwitchComponent
